import { el, VNode } from "@dhx/ts-common/dom";
import { IHandlers } from "@dhx/ts-common/types";
import { IEventSystem } from "@dhx/ts-common/events";
import { eventHandler, locate } from "@dhx/ts-common/html";
import {
	DataEvents,
	DiagramEvents,
	IShapeToolbarConfig,
	SelectionEvents,
	IDiagramEventHandlersMap,
} from "./types";
import { View } from "@dhx/ts-common/view";
import { IDataItem } from "@dhx/ts-data";
import { ItemConfig, IBaseCoords } from "..";

export class Toolbar extends View {
	public config: any;
	private events: IEventSystem<DataEvents | SelectionEvents | DiagramEvents, IDiagramEventHandlersMap>;
	private _handlers: IHandlers;
	private _hidden: boolean;

	constructor(
		events: IEventSystem<DataEvents | DiagramEvents | SelectionEvents>,
		icons: IShapeToolbarConfig[]
	) {
		super(null, {
			height: 50,
			iconWidth: 30,
			gap: 16,
			icons,
		});
		this.events = events;
		this._handlers = {
			onclick: eventHandler(ev => locate(ev), {
				dhx_icon: (ev, id) => {
					this.events.fire(DiagramEvents.shapeIconClick, [id, ev]);
				},
			}),
		};
	}
	render(item: IDataItem, size: any, coords?: IBaseCoords): VNode {
		if (!item) return;

		const config = this.config;
		const icons = this._getIcons(item, config.icons);

		const width = config.iconWidth * icons.length + config.gap;
		const pos = this._getCoords(item, {
			width: width / size.scale,
			height: config.height / size.scale,
			x: coords.x,
			y: coords.y,
		});

		return el(
			"div",
			{
				class: "dhx_popup_toolbar",
				style: {
					display: this._hidden || !icons.length ? "none" : "block",
					maxHeight: this.config.height,
					width,
					top: (pos.y - size.top) * size.scale,
					left: (pos.x - size.left) * size.scale,
				},
				onclick: this._handlers.onclick,
			},
			[
				el(
					"div",
					{
						class: "dhx_item_toolbar",
					},
					icons
				),
			]
		);
	}
	hide() {
		this._hidden = true;
		this.paint();
	}
	show() {
		this._hidden = false;
		this.paint();
	}
	protected _getIcons(item: ItemConfig, icons: IShapeToolbarConfig[]): any[] {
		const tags = [];
		for (let i = 0; i < icons.length; i++) {
			const obj = icons[i];
			if (!obj.check || obj.check(item)) {
				const css = obj.css ? obj.css(item) : "";

				const tag = {
					_key: obj.id,
					class: "dhx_icon " + css,
					dhx_id: obj.id,
				};
				const content = typeof obj.content === "function" ? obj.content(item) : obj.content;
				if (typeof content === "string") {
					tag[".innerHTML"] = content;
					tags.push(el("div", tag));
				} else {
					tags.push(el("div", tag, [content]));
				}
			}
		}
		return tags;
	}
	protected _getCoords(target: ItemConfig, { width, height, x, y }): { x: number; y: number } {
		const type = target.$item.getBaseType();
		if (type === "line" && !target.$subSelected) {
			const GAP = 25;
			return {
				x: x + GAP,
				y: y - height / 2,
			};
		}

		const box = (type === "line" && target.$subSelected
			? target.title.text.find(i => i.id === target.$subSelected)
			: target
		).$item.getBox();
		const center = box.right / 2 + box.left / 2;
		const GAP = 8;
		return {
			x: center - width / 2,
			y: box.top - height - GAP,
		};
	}
}
